import { Button, Modal } from 'react-bootstrap'

interface IProps {
    show: boolean,
    onClose: () => void
}

const RefreshWarning = (props: IProps) => {
    return (
        <Modal bsSize='sm' backdrop='static' show={props.show} onHide={props.onClose}>
            <Modal.Header closeButton>Save Complete</Modal.Header>
            <Modal.Body>
                Due to processing time we are no longer auto-recalculating Pair Match Power on save. It may take up to 5 minutes for your changes to be reflected
            </Modal.Body>
            <Modal.Footer>
                <Button bsStyle='primary' onClick={props.onClose}>OK</Button>
            </Modal.Footer>
        </Modal>
    );
}

export default RefreshWarning;